<template>
	<div class="gallery-showcase">
		<!-- Main Image -->
		<swiper ref="swiperTop">
			<swiper-slide
				v-for="(image, index) in images"
				:key="index"
				class="gallery-showcase__selected-container"
			>
				<img :src="image">
			</swiper-slide>
		</swiper>
		<!-- Thumbnails -->
		<swiper
			class="gallery-showcase__thumbnails"
			:options="optionsThumbnails"
			ref="swiperThumbs"
		>
			<swiper-slide v-for="(image, index) in images" :key="index">
				<div class="gallery-showcase__thumbnail">
					<img :src="image" class="gallery-showcase__small-images">
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
	name: "GalleryShowcase",
	components: {
		swiper,
		swiperSlide
	},
	props: {
		images: {
			type: Array,
			default() {
				return [];
			}
		},
		swiperOptionsThumbs: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	computed: {
		optionsThumbnails() {
			const defaultOptions = {
				threshold: 10,
				centeredSlides: true,
				slidesPerView: "auto",
				touchRatio: 0.2,
				slideToClickedSlide: true
			};

			return {
				...defaultOptions,
				...this.swiperOptionsThumbs
			};
		}
	},
	mounted() {
		this.$nextTick(() => {
			const swiperTop = this.$refs.swiperTop.swiper;
			const swiperThumbs = this.$refs.swiperThumbs.swiper;
			swiperTop.controller.control = swiperThumbs;
			swiperThumbs.controller.control = swiperTop;
		});
	}
};
</script>

<style lang="scss">
.gallery-showcase {
	.swiper-container,
	.swiper-wrapper,
	.swiper-slide {
		width: 100%;
	}
}
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.gallery-showcase {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 30px;
	width: 300px;

	@media (min-width: 580px) and (max-width: 1200px) {
		width: 470px;
	}

	@media (min-width: 1200px) {
		width: 560px;
	}

	&__selected-container {
		img {
			width: 100%;
			margin: 0 auto;
		}
	}

	&__thumbnails {
		display: flex;
		justify-content: center;
		padding-bottom: 5px;
		margin-top: 10px;

		.swiper-wrapper {
			justify-content: space-around;
			transform: initial !important;
			align-items: center;
			order: 1;
			width: auto;

			.swiper-slide {
				width: auto !important;
				flex-shrink: 1;
			}
		}
	}

	&__thumbnail {
		width: 40px;
		padding: 0 2.5px 2px;
		cursor: pointer;

		&::after {
			content: "";
			width: 100%;
			position: absolute;
			height: 2px;
			background: transparent;
			border-radius: 10px;
			left: 0;
			right: 0;
			bottom: -5px;
			opacity: 0;
			transition: opacity 0.3s;

			@media (min-width: 580px) {
				height: 4px;
			}
		}

		@media (min-width: 580px) {
			width: 72px;
			padding: 0 8.5px 5px;

			&:hover {
				&::after {
					background: #fff;
					opacity: 0.4;
				}
			}
		}
	}

	&__small-images {
		width: 100%;
		display: block;
	}

	.swiper-slide-active {
		.gallery-showcase__thumbnail {
			position: relative;

			&::after {
				background: $orchid;
				opacity: 1;
			}
		}
	}
}
</style>
